export const salutationsMasters: string[] = ['Mr.', 'Ms.', 'M/S.', 'Mrs.'];
export const applicantStatusMasters: { [key: string]: string } = {
  // Individual: 'Individual (Resident)',
  // NRI: 'Individual (NRI)',
  Individual: 'Individual (Resident)',
  NRE: 'Individual (NRI-NRE)',
  NRO: 'Individual (NRI-NRO)',
};
export const nriApplicantStatusMasters: { [key: string]: string } = {
  // Individual: 'Individual (Resident)',
  // NRI: 'Individual (NRI)',
  NRE: 'Individual (NRI-NRE)',
  NRO: 'Individual (NRI-NRO)',
};
export const onboardingTypeMasters: { [key: string]: string } = {
  normal: 'Normal',
  minor: 'Minor',
};
export const nationalitiesMasters: string[] = ['Indian', 'Others'];

// 1 lakh = 0.1 million (MIL)
// 1 crore = 10 million (MIL) or 0.01 billion (BIL)
export const grossAnnualMasters = (locale: string): Array<{ key: string; value: string }> => {
  if (locale === "en-IN") {
    return [
      { key: "Below 1 lakh", value: 'BELOW 1 LAC' },
      { key: "1-5 lakhs", value: '1-5 LAC' },
      { key: "5-10 lakhs", value: '5-10 LACS' },
      { key: "10-25 lakhs", value: '10-25 LACS' },
      { key: '>25 lakhs - 1 crore', value: '>25 LACS - 1 CRORE' },
      { key: '> 1 crore', value: '> 1 CRORE' },
    ]
  } else {
    return [
      { "key": "Below 0.1 mil", "value": "BELOW 0.1 MIL" },
      { "key": "0.1-0.5 mil", "value": "0.1-0.5 MIL" },
      { "key": "0.5-1 mil", "value": "0.5-1 MIL" },
      { "key": "1-2.5 mils", "value": "1-2.5 MILS" },
      { "key": ">2.5 mils - 10 mils", "value": ">2.5 MILS - 10 MILS" },
      { "key": "> 10 mils", "value": "> 10 MILS" }
    ]
  }
}

export const PEPsMasters: string[] = ['I am PEP', 'I am Related to PEP', 'Not Applicable'];

export const addressTypesMasters: string[] = [
  'Residence/Business',
  'Residence',
  'Business',
  'Registered Office',
  'Unspecified',
];

export const genderMasters: string[] = ['Male', 'Female', 'Others'];

export const maritalMasters: string[] = ['Single', 'Married', 'Others'];

export const occupationDetailsMasters: string[] = [
  'Agriculturist',
  'Business',
  'Doctor',
  'Housewife',
  'Professional',
  'Retired',
  'Service',
  'Student',
  'Others',
];

export const uboOccupationDetailsMasters: string[] = [
  "PVT.SECTOR SERVICE",
  "PUBLIC SECTOR",
  "GOVT.SERVICE",
  "HOUSEWIFE",
  "DEFENCE",
  "PROFESSIONAL",
  "RETIRED",
  "BUSINESS",
  "AGRICULTURE",
  "STUDENT",
  "FOREX DEALER",
  "OTHERS",
]

export const IdentityProofsMasters: string[] = [
  'Photo PAN Card',
  'Passport',
  "Voter's ID",
  'Driving License',
  'Aadhar Card',
];

export const IdProofsMasters: string[] = [
  'PAN Card',
  'Aadhar Card',
  'Driving License',
  'Passport',
];
export const idProofLabelsMasters: { [key: string]: string } = {
  'PAN Card': 'PAN Number',
  'Aadhar Card': 'Aadhar Number(Last 4 Digits)',
  'Driving License': 'Driving License Number',
  'Passport': 'Passport Number',
};

export const uboIdentificationTypeMasters: string[] = [
  "Passport",
  "Election ID Card",
  "PAN Card",
  "ID Card",
  "Driving License",
  "UIDIA/Aadhar Card",
  "NREGA Job Card",
  "Others",
  "Not Categorized",
  "TIN(Taxpayer Identification Number)",
  "Company Identification Number",
  "US GIIN",
  "Global Entity Identification Number",
]

export const AddressProofsMasters: string[] = [
  'Passport',
  "Voter's ID",
  'Ration Card',
  'Electricity Bill',
  'Landline/Telephone Bill',
  'Gas Bill',
  'Latest Bank Statement/Passbook',
  'Latest Depository Account Statement',
];

export const BankAccountProofsMasters: string[] = [
  'Bank Statement with IFSC printed on it',
  'Cancelled cheque leaf verified',
  'Letter from the bank giving account details',
  'Passbook (showing bank account details)',
];

export const DrawDownMasters: number[] = [1, 2, 3, 4];

export const filterApplicationTypes = [
  { key: 'individual', value: 'Individual (Resident)' },
  // { key: 'non_individual', value: 'Non-Individual' },
  // { key: 'poa', value: 'Individual (POA)' },
  { key: 'minor', value: 'Minor' },
  { key: 'nri', value: 'Individual (NRI)' },
  { key: 'non_individual', value: 'Non-Individual' },
  // { key: 'nri_poa', value: 'Individual (NRI-POA)' },
];

export const ModeOfHoldingTypes = [
  { key: 'single', value: 'Single' },
  { key: 'either or survivor', value: 'Either Or Survivor' },
  { key: 'joint', value: 'Joint' },
];

export const DiyInvestor = [
  { key: "true", value: 'Yes' },
  { key: "false", value: 'No' },
]

export const OnboardingType = [
  { key: 'physical', value: 'Physical' },
  { key: 'digital', value: 'Digital' },
]

export const AccountType = [
  { key: 'poa', value: 'POA' },
  { key: 'executionary', value: 'Executionary' },
  { key: 'advisory', value: 'Advisory' }
]

export const BseStatusMapper = [
  { key: 'disabled', value: 'Disabled' },
  { key: 'pending', value: 'Pending' },
  { key: 'active', value: 'Active' },
  { key: 'failed', value: 'Failed' },
]

export const IMAGE_UPLOAD_FORMATS = ['image/jpeg', 'application/pdf', 'image/png', 'image/jpg'];

export const INVESTOR_IMAGE_UPLOAD_FORMATS = ['image/png', 'image/jpg', 'image/jpeg'];

export const APPLICATION_STATUS: { [key: string]: string } = {
  draft: 'Draft',
  sent_to_applicant1: 'eSign Pending with Applicant 1',
  approved_by_applicant1: 'Approved by 1st Applicant',
  approved_by_applicant2: 'Approved by 2nd Applicant',
  approved_by_applicant3: 'Approved by 3rd Applicant',
  approved_by_trustee: 'Approved by Trustee',
  approved_by_fundmanager: 'Approved by investment manager',
  invitationexpired: 'Invitation Expired',
  completed: 'Completed',
  signed: 'Completed',
  rejected: 'Rejected',
};

export const POA_APPLICATION_STATUS: { [key: string]: string } = {
  draft: 'Draft',
  sent_to_poa_approver: 'Sent to POA approver',
  sent_to_amc_approver: 'Sent to Checker',
  sent_to_authorised_signatories: 'Sent to authorised signatories',
  approved_by_authorised_signatories: 'Approved by authorised signatories',
  approved_by_fundmanager: 'Approved by investment manager',
  approved_by_trustee: 'Approved by trustee',
  invitationexpired: 'Invitation Expired',
  signed: 'Completed',
  completed: 'Completed',
  rejected: 'Rejected',
};

export const ESIGN_STATUS: { [key: string]: string } = {
  NOT_GENERATED: 'notgenerated',
  PENDING_SIGNATURE: 'pendingsignature',
  SIGNED: 'signed',
  EXPIRED: 'expired',
};

export enum USER_ROLES {
  SUPER_ADMIN = 'superadmin',
  AMC_ADMIN = 'amcadmin',
  RM = 'rm',
  OPE = 'ope',
  DISTRIBUTOR = 'distributor',
  INVESTOR = 'investor',
  FUND_MANAGER = 'fundmanager',
  TRUSTEE = 'trustee',
  WITNESS = 'witness',
  APPLICATION = 'application',
  SUBDISTRIBUTOR = 'subdistributor',
  POAAPPROVER = 'poaapprover',
  AMCAPPROVER = 'amcapprover',
  AUTHORISEDSIGNATORY = 'authorisedsignatory',
  POACHECKER = 'POA_CH',
  ANALYST = "analyst"
}
// Roles that should have the same access/behavior as RM (e.g., OPE)
export const RM_LIKE_ROLES: string[] = [USER_ROLES.RM, USER_ROLES.OPE];


export enum ROLE_TYPE {
  REX = 'REX',
  RSM = 'RSM',
  RTL = 'RTL',
  RWM = 'RWM',
}

export const ApplicationStatusBasedOnRole: { [key: string]: { [key: string]: string } } = {
  [USER_ROLES.POAAPPROVER]: {
    ...POA_APPLICATION_STATUS,
    sent_to_poa_approver: 'Pending',
  },
  [USER_ROLES.AMCAPPROVER]: {
    ...POA_APPLICATION_STATUS,
    sent_to_amc_approver: 'Pending',
  },
};

export const Relations = [
  'Mother',
  'Father',
  'Daughter',
  'Son',
  'Spouse',
  'Brother',
  'Sister',
  'Others',
];

export const ContactRelations: { [key: string]: string } = {
  self: 'Self',
  spouse: 'Spouse',
  dependent_children: 'Dependent Children',
  dependent_parents: 'Dependent Parents',
  depending_siblings: 'Depending Siblings',
};

export const NomineeRelations = [
  //   'MOTHER',
  //   'FATHER',
  //   'DAUGHTER',
  //   'SON',
  //   'SPOUSE',
  //   'BROTHER',
  //   'SISTER',
  //   'OTHERS',

  "FATHER",
  "MOTHER",
  "HUSBAND",
  "SPOUSE",
  "GRANDFATHER",
  "GRANDMOTHER",
  "SISTER",
  "DAUGHTER",
  "SELF",
  "BROTHER",
  "SON",
  "DAUGHTER IN LAW",
  "OTHERS"
];

export const relatedRelations = ['MOTHER', 'FATHER', 'DAUGHTER', 'SON', 'SPOUSE', 'OTHERS'];
export const relationshipsWithGuardian = ['MOTHER', 'FATHER', 'COURT APPOINTED LEGAL GUARDIAN']

export const adminSupportMaster: { [key: string]: string } = {
  unlock_user: 'Unlock User',
  check_whitelisted: 'Check Whitelisted',
  whitelist_user: 'Whitelist User',
  unwhitelist_user: 'Unwhitelist User',
  // change_expired_status: 'Change Expired Status',
  // change_status_to_draft: 'Change Status to draft',
};

export const IS_DOB_APPLICABLE_FOR_AMC = true;

export const REJECTED_ROLES: { [key: string]: string } = {
  poaapprover: 'POA Approver',
  amcapprover: 'Checker',
};

//this is the new list of investor type for non individual
// Company
// Corporate
// HUF
// AOP
// Partnership Firm
// Trust
// Proprietorship
export const investorTypeMasters: { [key: string]: string } = {
  corporate: 'Corporate',
  trust: 'Trust',
  partnership_firm: 'Partnership Firm',
  huf: 'HUF',
  // govt_bodies: 'Army/ Government Bodies',
  // registered_society: 'Registered Society',
  // fii_fpi: 'FII/FPI',
  // bank: 'Bank',
  // institutional_investor: 'Institutional Investor',
  // unincorporated_or_body_of_individuals: 'Unincorporated association or a body of individuals',
  // foreign_entity: 'Foreign Entity',
  company: 'Company',
  // llp: 'LLP',
  aop: "AOP",
  sole_proprietorship: "Sole Proprietorship",
};
export const IS_PENNYDROP_APPLICABLE_FOR_AMC = true;

export const getGroupNameMaster = ['Group-A', 'Group-B', 'Group-C'];

export const NON_INDIVIDUAL_APPLICATION_STATUS: { [key: string]: string } = {
  draft: 'Draft',
  sent_to_amc_approver: 'Sent to Checker',
  sent_to_authorised_signatories: 'Sent to authorised signatories',
  approved_by_authorised_signatories: 'Approved by authorised signatories',
  approved_by_fundmanager: 'Approved by investment manager',
  approved_by_trustee: 'Approved by trustee',
  invitationexpired: 'Invitation Expired',
  signed: 'Completed',
  completed: 'Completed',
  rejected: 'Rejected',
};

export const CpUboCodesMaster: { [key: string]: string } = {
  C01: '- CP of legal person-ownership',
  C02: '- CP of legal person-other means',
  C03: '- CP of legal person-senior managing official',
  C04: '- CP of legal arrangement-trust-settlor',
  C05: '- CP of legal arrangement-trust-trustee',
  C06: '- CP of legal arrangement-trust-protector',
  C07: '- CP of legal arrangement-trust-beneficiary',
  C08: '- CP of legal arrangement-trust-other',
  C09: '- CP of legal arrangement-trust-other-settlor-equivalent',
  C10: '- CP of legal arrangement-trust-other-trustee-equivalent',
  C11: '- CP of legal arrangement-trust-other-protector-equivalent',
  C12: '- CP of legal arrangement-trust-other-beneficiary-equivalent',
  C13: '- CP of legal arrangement-trust-other-other-equivalent',
  C14: '- Unknown',
};

export const uboIdentificationTypeMaster: { [key: string]: string } = {
  "Passport": "Passport",
  "Election ID Card": "Election ID Card",
  "PAN Card": "PAN Card",
  "ID Card": "ID Card",
  "Driving License": "Driving License",
  "UIDIA/Aadhar Card": "UIDAI/Aadhar Card",
  "NREGA Job Card": "NREGA Job Card",
  "Others": "Others",
  "Not Categorized": "Not Categorized",
  "TIN(Taxpayer Identification Number)": "TIN(Taxpayer Identification Number)",
  "Company Identification Number": "Company Identification Number",
  "US GIIN": "US GIIN",
  "Global Entity Identification Number": "Global Entity Identification Number",

}
export const controllingPersonsNationalitiesMasters: string[] = ['Indian', 'Others'];

//Application types
export enum APPLICATION_TYPE {
  INDIVIDUAL = 'individual',
  NON_INDIVIDUAL = 'non_individual',
  MINOR = "minor",
  NRI = "nri"
}

export const AMC_APPROVER_CHECK_FOR_INDIVIDUAL = true;

export const ENABLE_EMAIL_OTP = true;

export const COMMENT_ROLES: { [key: string]: string } = {
  rm: 'RM',
  ope: 'OPE',
  distributor: 'Distributor',
  subdistributor: 'Sub Distributor',
  amcapprover: 'Checker',
  investor: 'Investor',
  rex: 'REX',
  rsm: 'RSM',
  rtl: 'RTL',
  rwm: 'RWM',
};

export const APPLICATION_STATUS_AMCAPPROVER_individual: { [key: string]: string } = {
  draft: 'Draft',
  sent_to_amc_approver: 'Sent to Checker',
  sent_to_applicant1: 'eSign Pending with Applicant 1',
  approved_by_applicant1: 'Approved by 1st Applicant',
  approved_by_applicant2: 'Approved by 2nd Applicant',
  approved_by_applicant3: 'Approved by 3rd Applicant',
  approved_by_trustee: 'Approved by Trustee',
  approved_by_fundmanager: 'Approved by investment manager',
  invitationexpired: 'Invitation Expired',
  completed: 'Completed',
  signed: 'Completed',
  rejected: 'Rejected',
};
export const IndividualApplicationStatusBasedOnRole: { [key: string]: { [key: string]: string } } =
{
  [USER_ROLES.AMCAPPROVER]: {
    ...APPLICATION_STATUS_AMCAPPROVER_individual,
    sent_to_amc_approver: 'Pending',
  },
};

export const APPLICATION_LISTING_STATUS: { [key: string]: string } = {
  draft: 'Draft',
  sent_to_applicant1: 'eSign Pending with Applicant 1',
  approved_by_applicant1: 'Approved by 1st Applicant',
  approved_by_applicant2: 'Approved by 2nd Applicant',
  approved_by_applicant3: 'Approved by 3rd Applicant',
  approved_by_trustee: 'Approved by Trustee',
  approved_by_fundmanager: 'Approved by investment manager',
  invitationexpired: 'Invitation Expired',
  completed: 'Completed',
  signed: 'Completed',
  rejected: 'Rejected',
  sent_to_poa_approver: 'Sent to POA approver',
  sent_to_amc_approver: 'Sent to Checker',
  sent_to_authorised_signatories: 'Sent to authorised signatories',
  approved_by_authorised_signatories: 'Approved by authorised signatories',
};

export enum APPLICATION_TYPE_FOR_DOCUMENTS {
  INDIVIDUAL = 'individual',
  NON_INDIVIDUAL = 'non_individual',
  INDIVIDUAL_POA = 'individual_poa',
  NRI = 'nri',
  NRI_POA = 'nri_poa',
  NOMINEE_DOC = 'nominee',
  NOMINEE_GUARDIAN = 'nomineeGuardian',
  MINOR = 'minor',
}
export const BankAccountTypeMaster: { [key: string]: string } = {
  Current: 'CURRENT',
  Savings: 'SAVING',
};

export const POABankAccountTypeMaster: { [key: string]: string } = {
  Current: 'CURRENT',
  Savings: 'SAVING',
  "Current POA": 'CURRENTPOA',
};

export const NRIBankAccountTypeMaster: { [key: string]: string } = {
  NRE: 'NRE',
  NRO: 'NRO',
};

export const POANRIBankAccountTypeMaster: { [key: string]: string } = {
  NRE: 'NRE',
  NRO: 'NRO',
  "CURRENT POA": 'CURRENTPOA',
};
export const DistributorTypesForUserManageMent: { [key: string]: string } = {
  Individual: 'individual',
  Company: 'company',
};

export const ENABLE_KRA_DOCUMENT_FETCH = false;

// CRED-02: SALT and SALT2 are hardcoded string literals in client-side source. If used for
// hashing/encrypting sensitive data, they are trivially extractable from the bundle and provide
// no real security. Pre-existing; accepted as-is. Should be moved to environment variables and
// any security relying on their secrecy reconsidered before a production hardening pass.
export const SALT = 'F2lNZWFxUH';
export const SALT2 = 'WTVPJel6dTGVocF';

export const ONBOARDING_OPTIONS: { [key: string]: string } = {
  otp: 'Verify via OTP',
  // email_consent: 'Email Consent',
};

export const ONBOARDING_VIA_OPTIONS: { [key: string]: string } = {
  physical: 'Physical',
  digital: 'Digital',
};

export const EmailConsentStatusMaster: { [key: string]: string } = {
  pending: 'Pending',
  rejected: 'Rejected',
  approved: 'Approved',
  revoked: 'Revoked',
};

export const ENABLE_Email_Consent = true;

export const BloodRelations = ['Father', 'Mother', 'Son', 'Daughter', 'Spouse'];

export const BSEConsentMaster: { [key: string]: string } = {
  true: 'Yes',
  false: 'No',
};

export const BseClientActivationStatusMaster: { [key: string]: string } = {
  pending: 'BSE Client Activation Pending',
  active: 'BSE Client Activated',
};

export const SUPPORT_STATUS: { [key: string]: string } = {
  sent_to_applicant1: 'eSign Pending with Applicant 1',
  approved_by_applicant1: 'Approved by 1st Applicant',
  approved_by_applicant2: 'Approved by 2nd Applicant',
  approved_by_applicant3: 'Approved by 3rd Applicant',
  approved_by_fundmanager: 'Approved by investment manager',
  sent_to_authorised_signatories: 'Sent to authorised signatories',
  approved_by_authorised_signatories: 'Approved by authorised signatories',
};

export const RoleTypes: { [key: string]: string } = {
  amc_rm: 'AMC',
  support_rm: 'Service',
};

export const HELDAWAY_PORTFOLIO_STATUS = "Transactions not allowed for Heldaway Portfolios."

export const currencyCodeMap: { [key: string]: string } = {
  'inr': "Rupees",
  'php': "Peso"
}

export const WEEKLYDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const WEB_NAME = 'THRIVE';

export const MPOWER_ACCOUNT_TYPE_MASTER: { [key: string]: string } = {
  POA: "POA",
  EXY: "EXECUTIONARY",
  ADV: "ADVISORY",
  EXECUTIONARY: "EXECUTIONARY",
  ADVISORY: "ADVISORY"
}

export const ENABLE_DIY_INVESTOR_ONBOARDING = true
export const ENABLE_ORDER_MANAGEMENT = false
export const ENABLE_PAYMENT_CHECKER = true
export const PHYSICAL_DIGITAL_FLOW = true // NEEDS TO BE FALSE IN PROD TILL API IS DEPLOYED
export const ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD = true

export const PAYMENT_LOOPBACK_URL = "https://mutualfunds.altifi.ai/bsetrade"

export const ORDER_ENTRY_SETTLEMENT_METHOD_CODE: { [key: string]: string } = {
  "Online Transfer": "0",
  "Client Offline Transfer": "1",
  "Initiate Transfer": "2",
};

export const REQUESTED_REPORTS: { [key: string]: string } = {
  1: "Title",
  3: "Executive Summary",
  4: "Family Portfolio Overview",
  5: "Portfolio Summary",
  6: "Portfolio Cashflow Summary",
  7: "Portfolio Highlights: Monthly Movements",
  8: "Holding Reports",
  16: "Transaction Reports- MFs",
  21: "Portfolio Attributes- Equity",
  22: "Portfolio Attributes- Fixed Income",
  23: "Asset Management Concentration",
  24: "Concentration Analysis",
  25: "Portfolio Liquidity Analysis",
  26: "IPS Frameworks/ Guidelines",
  27: "Top 10 Equity Mutual Fund Holding Overlap",
  28: "Annexure1",
  29: "Annexure2"
}

export const BSE_PAYMENT_FLOW = true
export const ONBOARDING_KYC_VERIFIED_MESSAGE = true
export const ONBOARDING_DOWNLOAD_APPLICATIONS_IGNORE_STATUS_CHECK = true
export const DOCUMENT_UPLOAD_DOWNLOAD_APPLICATION = true
export const ONBOARDING_DEMAT_DETAILS = false
export const NEXEDGE_INVESTMENT_PREFERENCE = true
export const NEXEDGE_MDMS_APIS = true

export const OTPDisclaimer = "Keep Your Password/Pin/OTP private & confidential to avoid any misuse or unauthorised trades."

export const leegalityText = "Dear Customer, an email has been sent from Leegality for eSigning the application! Kindly complete the eSign."

export const CONTENT_TYPE = {
  PDF: "application/pdf",
  EXCEL: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
}


export const INDIVIDUAL_ONBOARDING_CHAR_LIMIT = {
  PERSONAL_DETAILS: {
    FIRST_NAME: 70,
    LAST_NAME: 70,
    FULL_NAME: 70
  }
}

export const MINOR_ONBOARDING_CHAR_LIMIT = {
  PERSONAL_DETAILS: {
    GUARDIAN_FIRST_NAME: 120,
    GUARDIAN_LAST_NAME: 120,
    GUARDIAN_FULL_NAME: 120,
    MINOR_FIRST_NAME: 70,
    MINOR_LAST_NAME: 70
  }
}

export const NON_INDIVIDUAL_ONBOARDING_CHAR_LIMIT = {
  CONTRIBUTOR_DETAILS: {
    NAME_OF_ENTITY: 70
  }
}

export const MAX_SCHEMES_SELECTED = 5

export const REPORTS_FILTER_TYPE_OPTIONS: Array<{ key: string; value: string; }> = [
  { key: "FAMILY", value: "FAMILY" },
  { key: "CLIENT", value: "CUSTOMER" },
  { key: "PORTFOLIO", value: "PORTFOLIO" }
]

export const ELOG_BSE = `Thank you. Your application is submitted successfully. As a next step, you are requested to authenticate your application by clicking the BSE ELOG link below to enable transaction processing. You could ELOG authenticate through an e-mail link sent to your registered email id from BSE within the next 5 days. Do check your all your mailboxes for this alert.`

export const PREFACE_DIY_ONBOARDING_OBJ = {
  message1: `We want to ensure you have a smooth onboarding experience and hence we would request you to have the following details ready:`,
  message2: `
      PAN number, 
      Primary Bank Account Details like IFSC code,bank account number, 
      Any Identity number for adding nominees in your account. E.g., Either of Aadhar, PAN, Passport, Driving license etc. 
    `
}

export const ECAS_INFO = "To review the overall MF portfolio in your name, the data is being fetched from MF Central for folios held in your name in the same holding pattern.Thriveiti urges you to check the completeness of data or its accuracy."

export const NO_DATA_AVAILABLE = "No data found."

export const BONDS_LINK = "https://altifi.ai/bonds/corporate-bonds"

export const NRIFLOW = true

export const WAITING_FOR_CLIENT_AUTHENTICATION = "WAITING FOR CLIENT AUTHENTICATION"

export const NO_RECOMMENDATIONS = "There are no recommendations at the moment."
export const INV_MAND_SWITCH = "If you have Created New Mandate. Please complete the Mandate Authentication."
export const RM_MAND_SWITCH = "In case of New Mandate, please ensure Mandate Authentication with Investor."

export const NEFT_DETAILS_MAPPER: { [key: string]: string } = {
  beneficiary_name: 'Beneficiary Name',
  beneficiary_account_number: 'Beneficiary Account No.',
  ifsc_code: 'IFSC Code',
  branch_name: 'Branch Name',
  branch_address: 'Branch Address',
  contact_number: 'Contact Number'
};

export const NON_INDIVIDUAL_RISK_SCORE_MSG = "Please invest as per your company’s investment policy (board resolution, deed etc) which covers the investment objective, time horizon and risk appetite"

export const SWP_FIRST_ORDER_FLAG_LABEL = "Withdraw 1st Installment Today"

export const STP_FIRST_ORDER_FLAG_LABEL = "Transfer 1st Installment Today"

export const COMMON_EDIT = true;

export const FUND_DETAILS_FREQUENCY = "MONTHLY";

export const NON_MF_FUNDS_FILTER: Array<{ label: string; value: string }> = [
  { label: 'ALL', value: 'ALL' },
  { label: 'External Transactions', value: 'TRADE_DATA' },
  { label: 'Corporate Actions', value: 'BENEFIT_DATA' },
  { label: 'Miscellaneous Transactions', value: 'MISC_DATA' }
]

export const MAX_FAMILY_MEMBERS = 15
